import { buildSearchFilterProps, sortStringColumn } from '../../../../components/tables/utils'

export const buildIssuersTableColumns = () => [
  {
    title: 'Bank',
    dataIndex: 'issuerName',
    sorter: sortStringColumn({ dataIndex: 'issuerName' }),
    ...buildSearchFilterProps({ dataIndex: 'issuerName' }),
  },
  {
    title: 'Customer ID',
    dataIndex: 'customerCode',
    sorter: sortStringColumn({ dataIndex: 'customerCode' }),
    ...buildSearchFilterProps({ dataIndex: 'customerCode' }),
  },
  {
    title: 'Customer Type',
    dataIndex: 'customerType',
    sorter: sortStringColumn({ dataIndex: 'customerType' }),
    ...buildSearchFilterProps({ dataIndex: 'customerType' }),
  },
]
